import { render, staticRenderFns } from "./FormSubmittedMessage.vue?vue&type=template&id=5fd2837f"
import script from "./FormSubmittedMessage.vue?vue&type=script&lang=js"
export * from "./FormSubmittedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports